export type DashboardThemePreference = "dark" | "light" | "system";

const THEME_PREFERENCE_KEY = "refinement-canvas.dashboard.theme-preference";

export function loadDashboardThemePreference(): DashboardThemePreference {
  if (typeof window === "undefined") {
    return "system";
  }

  return normalizeThemePreference(localStorage.getItem(THEME_PREFERENCE_KEY));
}

export function saveDashboardThemePreference(preference: DashboardThemePreference): void {
  try {
    localStorage.setItem(THEME_PREFERENCE_KEY, preference);
  } catch {
    // localStorage が使えない環境では、テーマ保存だけを諦める。
  }
}

function normalizeThemePreference(value: unknown): DashboardThemePreference {
  return value === "dark" || value === "light" || value === "system" ? value : "system";
}
